import { TableHeadersType } from "./tableHeadersType";

export const ALL_CLIENT_LOCK_DATE_HEADERS: TableHeadersType[] = [
  {
    label: "CLIENT NAME",
    value: "client_name",
  },
  {
    label: "EXPENSE Invoices",
    value: "expense",
  },
  {
    label: "SALES Invoices",
    value: "revenue",
  },
  {
    label: "Other Entries",
    value: "other",
  },
  {
    label: "MANUFACTURING JOURNAL",
    value: "manufacturingJournal",
  },

];

export const CLIENT_SORTING_DATA = [
 

  {
    _id: "client_code#asc",
    id: "Client Code - Ascending",
    value: "asc",
    name: "Client Code - Ascending",
  },
  {
    _id: "client_code#desc",
    id: "Client Code - Descending",
    value: "desc",
    name: "Client Code - Descending",
  },
  {
    _id: "client_name#asc",
    id: "Client Name - Ascending",
    value: "asc",
    name: "Client Name - Ascending",
  },
  {
    _id: "client_name#desc",
    id: "Client Name - Descending",
    value: "desc",
    name: "Client Name - Descending",
  },

];